import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { SearchIcon } from 'components/Icons';
import { MENU_ICON_SIZE } from './navigationUtils';
import { I18nContext } from 'components/I18n';
import { Placeholder } from 'components/SearchInput/Styles';
import { StyledSearchLink } from './Styles';

function SearchLink({ onClick, iconSize }) {
  const searchMenu = useSelector(state => state.settings.searchMenu);
  const label = searchMenu.title;
  const i18nContext = useContext(I18nContext);

  return (
    <StyledSearchLink
      onClick={onClick}
      to={{ name: 'search' }}
      data-content={label}
    >
      <SearchIcon size={iconSize} />
      <Placeholder
        aria-hidden="true"
        style={{
          // prevent font from increasing when mouseover
          fontWeight: 'normal',
          // search icon size + 14px close icon - 40px padding from parent
          marginLeft: `calc(${MENU_ICON_SIZE} + 14px - 40px)`,
        }}
      >
        {i18nContext.formatText('search')}
      </Placeholder>
    </StyledSearchLink>
  );
}

SearchLink.propTypes = {
  onClick: PropTypes.func,
  iconSize: PropTypes.number,
};

export default React.memo(SearchLink);
